import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import ConfirmationPopup from "../../packages/ConfirmationPopup";

import { useUnsavedChanges } from "../../hooks/useUnsavedChanges";

import { CustomModalButtons } from "../../constants/global.constants";

import "./index.scss";

const UnsavedChangesDialog = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const {
    showDialog,
    setShowDialog,
    targetPathRef,
    pendingActionRef,
    allowActionRef,
  } = useUnsavedChanges();

  const handleClose = (action) => {
    setShowDialog(false);

    if (action === CustomModalButtons.CONFIRM) {
      const navigatePath = targetPathRef.current;
      if (navigatePath) {
        allowActionRef.current = true;
        navigate(navigatePath);
      } else {
        allowActionRef.current = true;
        const actionHandler = pendingActionRef.current;
        actionHandler && actionHandler();
        allowActionRef.current = false;
      }
    } else {
      allowActionRef.current = false;
    }
    targetPathRef.current = null;
    pendingActionRef.current = null;
  };

  if (!showDialog) return null;

  return (
    <ConfirmationPopup
      header={t("unsavedChanges.title")}
      description={t("unsavedChanges.description")}
      confirmBtn={t("ValueStrings.okay")}
      cancelBtn={t("ValueStrings.cancel")}
      onClose={handleClose}
      customClassName="unsaved-changes-dialog"
      width="450px"
    />
  );
};

export default UnsavedChangesDialog;
